export function isG2ReviewEnabled() {
  // Uncomment the following block to disable G2 Reviews and selectively enable it on the client side
  return true; // localStorage.getItem('plerion.isG2ReviewEnabled') === 'true';
}

export function isCustomChecksEnabled() {
  return localStorage.getItem('plerion.enableCustomChecks') === 'true';
}

